__turbopack_context__.v({
  "active": "slide-module__hsFOfa__active",
  "dot": "slide-module__hsFOfa__dot",
  "dots": "slide-module__hsFOfa__dots",
  "slide": "slide-module__hsFOfa__slide",
  "slider": "slide-module__hsFOfa__slider",
});
